import { render, staticRenderFns } from "./InsideProductt.vue?vue&type=template&id=7e561bad&scoped=true"
import script from "./InsideProductt.vue?vue&type=script&lang=js"
export * from "./InsideProductt.vue?vue&type=script&lang=js"
import style0 from "./InsideProductt.vue?vue&type=style&index=0&id=7e561bad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e561bad",
  null
  
)

export default component.exports